/** Generic user-facing message for DoubtBuddy socket failures (matches Android). */
export const DOUBT_BUDDY_SOCKET_GENERIC_ERROR = "Something went wrong";

/**
 * Detects insufficient-token / API error chunks streamed on `query-update-solution`.
 * Ported from Android `useDoubtBuddyRevise.isSocketErrorChunk`.
 */
export function isDoubtBuddySocketErrorChunk(chunk: string): boolean {
  const text = chunk.trim();
  if (!text) return false;
  return /^Error:\s*Error code:\s*402\s*-\s*\{[\s\S]*['"]error['"]\s*:/i.test(
    text,
  );
}

/** True when assembled or persisted markdown is a DoubtBuddy socket error payload. */
export function isDoubtBuddySocketErrorMarkdown(text: string): boolean {
  const trimmed = text.trim();
  if (!trimmed) return false;
  return isDoubtBuddySocketErrorChunk(trimmed);
}
